@if (isLoading()) {
  <div class="guard-loading-indicator" animate.enter="indicator-enter" animate.leave="indicator-leave">
    <div class="glass-container">
      <div class="liquid-blob"></div>
      <div class="content">
        <div class="spinner"></div>
        <span class="text">{{ displayText() }}</span>
      </div>
    </div>
  </div>
}